import { Subscription } from 'rxjs';

export class SingleHttpSubscription {
    #httpSub: Subscription | null = null;

    get httpSub(): Subscription | null {
        return this.#httpSub;
    }

    set httpSub(httpSub: Subscription | null) {
        if (this.#httpSub) this.#httpSub.unsubscribe();

        this.#httpSub = httpSub;
    }
}
